<template>
  <div class="page">
    <ScreenAdapter>
      <div class="main">
        <div class="header">
          <div class="title">智慧养老数据监控平台</div>
        </div>
        <div class="content">
          <div class="left-con">
            <!-- 组件调用分析 -->
            <div class="left-top">
              <div class="item-title">
                <div class="main-title">组件调用分析</div>
                <div class="title-date">{{ startDate }}——{{ endDate }}</div>
              </div>
              <div class="components-con">
                <div id="component-use"></div>
              </div>
            </div>
            <!-- 数据上/下行统计 -->
            <div class="left-center">
              <div class="item-title">
                <div class="main-title">数据上/下行统计</div>
                <!-- <div class="title-date">2022/03/18——2022/04/18</div> -->
              </div>
              <div class="up-down-con">
                <div id="up-down"></div>
              </div>
            </div>
            <div class="left-bottom">
              <div class="item-title">
                <div class="main-title">实时组件调用详细</div>
                <!-- <div class="title-date">2022/03/18——2022/04/18</div> -->
              </div>
              <div class="table-con">
                <el-table
                  :data="componentTableData"
                  height="240"
                  style="width: 100%; overflow: auto"
                  :highlight-current-row="false"
                  :row-class-name="tableRowClassName"
                  header-row-class-name="header-class"
                >
                  <el-table-column prop="createdDate" label="时间" width="120">
                    <template slot-scope="scope">
                      <span>{{
                        scope.row.createdDate
                          ? scope.row.createdDate.substring(5, 16)
                          : "无"
                      }}</span>
                    </template>
                  </el-table-column>
                  <el-table-column prop="moduleTypeName" label="业务类型">
                  </el-table-column>
                  <el-table-column
                    prop="branchName"
                    label="操作单位"
                    width="180"
                  >
                  </el-table-column>
                </el-table>
              </div>
            </div>
          </div>
          <div class="right-con">
            <div class="right-main">
              <div class="item-title">
                <div class="main-title">综合情况</div>
                <!-- <div class="title-date">2022/03/18——2022/04/18</div> -->
              </div>
              <div class="data-wrapper">
                <div
                  class="data-item"
                  v-for="item in board_arr"
                  :key="item.title"
                >
                  <div class="data-title">{{ item.title }}</div>
                  <div class="data-detail">
                    <div class="big-num">{{ item.num }}</div>
                    <div class="data-rate">
                      较昨日<span v-if="item.rate >= 0" style="color: #50b88d"
                        >↑</span
                      ><span v-else style="color: #bd6969">↓</span
                      >{{ item.rate > 0 ? item.rate : item.rate * -1 }}%
                    </div>
                  </div>
                </div>
              </div>
              <div class="data-chart">
                <div class="select-con">
                  <div
                    class="select-item"
                    :class="currentTrend === item.value ? 'select-active' : ''"
                    v-for="item in select_arr"
                    :key="item.title"
                    @click="handelSelectTime(item)"
                  >
                    {{ item.title }}
                  </div>
                </div>
                <div id="data-chart"></div>
              </div>
            </div>
            <div class="right-bottom">
              <div class="bottom-left">
                <div class="item-title">
                  <!-- <div class="main-title">实时组件调用详细</div> -->
                  <div class="bottom-title">热门功能使用TOP10</div>
                  <div class="title-date">{{ startDate }}——{{ endDate }}</div>
                </div>
                <div class="handle-con">
                  <!-- <div class="bottom-title">热门功能使用TOP10</div> -->
                  <div class="select-con">
                    <div
                      class="select-item"
                      :class="
                        currentClient === item.value ? 'select-active' : ''
                      "
                      v-for="item in select_client"
                      :key="item.title"
                      @click="handelSelectClient(item)"
                    >
                      {{ item.title }}
                    </div>
                  </div>
                </div>
                <div class="bottom-chart-con">
                  <!-- <div id="component-use"></div> -->
                  <div id="live-chart"></div>
                </div>
              </div>
              <div class="bottom-right">
                <div class="item-title">
                  <div class="main-title">实时操作记录</div>
                  <!-- <div class="title-date">2022/03/18——2022/04/18</div> -->
                </div>
                <div class="bottom-table">
                  <el-table
                    :data="handleTableData"
                    height="240"
                    style="width: 100%; overflow: auto"
                    :highlight-current-row="false"
                    :row-class-name="tableRowClassName"
                    header-row-class-name="header-class"
                  >
                    <el-table-column
                      prop="createdDate"
                      label="时间"
                      width="120"
                    >
                      <template slot-scope="scope">
                        <span>{{
                          scope.row.createdDate
                            ? scope.row.createdDate.substring(5, 16)
                            : "无"
                        }}</span>
                      </template>
                    </el-table-column>
                    <el-table-column prop="moduleTypeName" label="业务类型">
                    </el-table-column>
                    <el-table-column
                      prop="branchName"
                      label="操作单位"
                      width="180"
                    >
                    </el-table-column>
                  </el-table>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </ScreenAdapter>
  </div>
</template>

<script>
import ScreenAdapter from "@/components/ScreenAdapter"; // 自适应组件
import DataProgress from "@/components/Progress"; // 进度条组件
import Highcharts from "highcharts";
import upDownChart from "../charts/data-board/up-down.js";
import componentUseChart from "../charts/data-board/component-use.js";
import useChart from "../charts/data-board/use-chart.js";
import { dataMonitoring } from "../api/dataBoard";

export default {
  components: {
    ScreenAdapter,
    DataProgress,
  },
  data() {
    return {
      branchId: 6627,
      startDate: null,
      endDate: null,
      board_arr: [],
      dayList: [],
      currentTrend: 1,
      select_arr: [
        {
          title: "应用启用趋势",
          value: 1,
        },
        {
          title: "平均在线趋势",
          value: 2,
        },
      ],
      currentClient: 1,
      select_client: [
        {
          title: "PC端",
          value: 1,
        },
        {
          title: "工作APP",
          value: 2,
        },
      ],
      component_data: [
        {
          name: "用户统一登录组件",
          value: null,
        },
        {
          name: "入住评估组件",
          value: null,
        },
        {
          name: "床码绑定组件",
          value: null,
        },
        {
          name: "床码解绑组件",
          value: null,
        },
        {
          name: "护工组件",
          value: null,
        },
      ],
      upDown_data: {},
      componentTableData: [],
      use_data: {},
      startup: {},
      averageOnline: {},
      pcHot: [
        {
          name: "预约管理",
          value: null,
        },
        {
          name: "服务单管理",
          value: null,
        },
        {
          name: "长者档案",
          value: null,
        },
        {
          name: "报警管理",
          value: null,
        },
        {
          name: "巡防计划管理",
          value: null,
        },
        {
          name: "账单查询",
          value: null,
        },
      ],
      appHot: [
        {
          name: "预约管理",
          value: null,
        },
        {
          name: "服务单管理",
          value: null,
        },
        {
          name: "长者档案",
          value: null,
        },
        {
          name: "报警管理",
          value: null,
        },
        {
          name: "巡防计划管理",
          value: null,
        },
        {
          name: "账单查询",
          value: null,
        },
      ],
      function_data: [
        {
          name: "预约管理",
          value: null,
        },
        {
          name: "服务单管理",
          value: null,
        },
        {
          name: "长者档案",
          value: null,
        },
        {
          name: "报警管理",
          value: null,
        },
        {
          name: "巡防计划管理",
          value: null,
        },
        {
          name: "账单查询",
          value: null,
        },
      ],
      handleTableData: [],
    };
  },
  created() {
    this.getData();
  },
  methods: {
    async getData() {
      let startDate = this.GetDateStr(-15);
      let endDate = this.GetDateStr(15);
      this.startDate = startDate;
      this.endDate = endDate;
      let json = {
        branchId: this.branchId,
        rows: 5,
        startDate,
        endDate,
      };
      try {
        let res = await dataMonitoring(json);
        this.dayList = res.data.data.dayList;
        // 上下行统计
        this.upDown_data = {
          up: res.data.data.upNum,
          down: res.data.data.downNum,
        };
        // 组件调用分析(左上)
        this.component_data.forEach((item, e) => {
          res.data.data.moduleInvoking.forEach((el, index) => {
            if (e == index) {
              this.$set(item, "value", el);
            }
          });
        });
        // 应用启动趋势
        this.startup = {
          client_data: res.data.data.appLoginTimesList,
          PC_data: res.data.data.pcLoginTimesList,
        };
        // 平均在线趋势
        this.averageOnline = {
          client_data: res.data.data.appAverageOnlineTimeList,
          PC_data: res.data.data.pcAverageOnlineTimeList,
        };
        if (this.currentTrend == 1) {
          this.use_data = this.startup;
        } else {
          this.use_data = this.averageOnline;
        }
        // 组件调用分析(右上)
        this.board_arr = [
          {
            title: "平台启用人数",
            num: res.data.data.loginHumanNum,
            rate: res.data.data.loginHumanNumRatio,
          },
          {
            title: "平台启用次数",
            num: res.data.data.loginTimes,
            rate: res.data.data.loginTimesRatio,
          },
          {
            title: "平均在线时长（分钟）",
            num: res.data.data.averageOnlineTime,
            rate: res.data.data.onlineTimeRatio,
          },
        ];
        // pc端热门功能
        this.pcHot.forEach((item, e) => {
          res.data.data.pcOperationLog.forEach((el, index) => {
            if (e == index) {
              this.$set(item, "value", el);
            }
          });
        });
        // app工作热门
        this.appHot.forEach((item, e) => {
          res.data.data.appOperationLog.forEach((el, index) => {
            if (e == index) {
              this.$set(item, "value", el);
            }
          });
        });
        if (this.currentClient == 1) {
          this.function_data = this.pcHot;
        } else {
          this.function_data = this.appHot;
        }
        // 实时组件调用详细
        this.componentTableData = res.data.data.moduleInvokingLogBean;
        // 实时操作记录
        this.handleTableData = res.data.data.operationLogBean;
        this.drawCharts();
      } catch (error) {
        console.error(error);
      }
    },

    GetDateStr(AddDayCount) {
      let dd = new Date();
      dd.setDate(dd.getDate() + AddDayCount); //获取AddDayCount天后的日期
      let y = dd.getFullYear();
      let m =
        dd.getMonth() + 1 < 10 ? "0" + (dd.getMonth() + 1) : dd.getMonth() + 1; //获取当前月份的日期，不足10补0
      let d = dd.getDate() < 10 ? "0" + dd.getDate() : dd.getDate(); //获取当前几号，不足10补0
      return y + "-" + m + "-" + d;
    },

    drawCharts() {
      // 数据上下行统计
      Highcharts.chart("up-down", upDownChart(this.upDown_data, this.dayList));
      // 组件调用分析(左上)
      Highcharts.chart("component-use", componentUseChart(this.component_data));
      // 组件调用分析(右上)
      Highcharts.chart("data-chart", useChart(this.use_data, this.dayList));
      // 实时组件调用详细
      Highcharts.chart("live-chart", componentUseChart(this.function_data));
    },
    tableRowClassName({ rowIndex }) {
      if (rowIndex % 2 === 0) {
        return "simple-row";
      } else if (rowIndex % 2 === 1) {
        return "blue-row";
      }
      return "";
    },
    handelSelectTime(item) {
      this.currentTrend = item.value;
      if (this.currentTrend == 1) {
        this.use_data = this.startup;
      } else {
        this.use_data = this.averageOnline;
      }
      // 组件调用分析(右上)
      Highcharts.chart("data-chart", useChart(this.use_data, this.dayList));
    },
    handelSelectClient(item) {
      this.currentClient = item.value;
      if (this.currentClient == 1) {
        this.function_data = this.pcHot;
      } else {
        this.function_data = this.appHot;
      }
      // 实时组件调用详细
      Highcharts.chart("live-chart", componentUseChart(this.function_data));
    },
  },
};
</script>

<style lang="scss" scoped>
.page {
  width: 100%;
  min-height: 100%;
  background: #002e83;
}
.main {
  width: calc(100% - 64px);
  height: 100%;
  margin: 0 auto;
  position: relative;
  // background: url("../assets/home/index.png") no-repeat center;
  // background: url("../assets/home/bg.jpg") no-repeat center;
  background-size: contain;
  background-position: center 50px;
  overflow: hidden;
  ::v-deep .el-table {
    background: transparent !important;
    border: none !important;
  }
  ::v-deep .el-table th {
    background: transparent !important;
    border: none !important;
  }
  ::v-deep .el-table th,
  ::v-deep .el-table tr,
  ::v-deep .el-table td,
  ::v-deep .el-table__body-wrapper {
    border: none !important;
    background-color: transparent;
  }
  ::v-deep .el-table::before {
    height: 0 !important;
  }
  ::v-deep .el-table .el-table__cell {
    padding: 6px 0 !important;
  }
  ::v-deep .el-table .header-class {
    color: #ffffff;
    background: rgba(88, 200, 154, 0.4) !important;
    height: 30px;
  }
  ::v-deep .el-table--enable-row-hover .el-table__body tr:hover > td {
    background-color: rgba(0, 0, 0, 0) !important;
  }
  .header {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 1200px;
    height: 112px;
    background: url("../assets/home/title_bg.png") no-repeat center;
    margin: 0 auto;
    .title {
      font-size: 44px;
      font-family: Source Han Sans SC;
      font-weight: bold;
      color: #ffffff;
    }
  }
  .content {
    width: 100%;
    height: auto;
    min-height: 932px;
    display: flex;
    margin-top: 20px;
  }
  .item-title {
    display: flex;
    align-items: center;
    justify-content: space-between;
    box-sizing: border-box;
    width: 100%;
    // padding: 16px 12px;
    font-size: 16px;
    font-family: Microsoft YaHei;
    font-weight: bold;
    color: #ffffff;
    line-height: 28px;
    .main-title {
      font-size: 16px;
      font-family: Microsoft YaHei;
      font-weight: bold;
      color: #ffffff;
    }
    .title-date {
      font-size: 14px;
    }
  }
  .left-con {
    width: 600px;
    height: 100%;
    .left-top {
      box-sizing: border-box;
      width: 100%;
      height: 296px;
      padding: 16px 12px;
      background: #004299;
      .components-con {
        width: 100%;
        height: 245px;
        #component-use {
          width: 100%;
          height: 100%;
        }
      }
    }
    .left-center {
      box-sizing: border-box;
      width: 100%;
      height: 296px;
      padding: 16px 12px;
      background: #004299;
      margin-top: 20px;
      .up-down-con {
        width: 100%;
        height: 245px;
        #up-down {
          width: 100%;
          height: 100%;
        }
      }
    }
    .left-bottom {
      box-sizing: border-box;
      width: 100%;
      height: 300px;
      padding: 16px 12px;
      background: #004299;
      margin-top: 20px;
      .table-con {
        margin-top: 10px;
      }
    }
  }
  .right-con {
    flex: 1;
    margin-left: 20px;
    .right-main {
      box-sizing: border-box;
      padding: 16px 12px;
      width: 100%;
      height: 612px;
      background: #004299;
      .data-wrapper {
        width: 100%;
        display: flex;
        align-items: center;
        justify-content: space-around;
        margin-top: 20px;
        .data-item {
          box-sizing: border-box;
          width: 220px;
          height: 119px;
          padding: 22px 20px;
          background: url("../assets/data-board/kuang.png") no-repeat center;
          background-size: cover;
          .data-title {
            font-size: 16px;
            font-family: Microsoft YaHei;
            font-weight: bold;
            color: #ffffff;
            line-height: 28px;
          }
          .data-detail {
            display: flex;
            align-items: baseline;
            justify-content: space-between;
            margin-top: 15px;
            font-size: 16px;
            font-family: Microsoft YaHei;
            font-weight: 400;
            color: #ffffff;
            line-height: 28px;
          }
          .big-num {
            font-size: 28px;
            font-family: Microsoft YaHei;
            font-weight: bold;
            color: #50b88d;
            line-height: 28px;
          }
        }
      }
      .data-chart {
        position: relative;
        width: 100%;
        height: 380px;
        margin-top: 40px;
        .select-con {
          position: absolute;
          top: 0px;
          left: 30px;
          width: 300px;
          display: flex;
          align-items: center;
          justify-content: center;
          z-index: 2;
          .select-item {
            width: 106px;
            height: 30px;
            line-height: 30px;
            border: 1px solid #5792c9;
            border-radius: 4px;
            color: #ffffff;
            text-align: center;
            margin: 2px 4px;
            cursor: pointer;
          }
          .select-active {
            background: #5792c9;
          }
        }
        #data-chart {
          width: 100%;
          height: 100%;
        }
      }
    }
    .bottom-title {
      font-size: 18px;
      font-family: Microsoft YaHei;
      font-weight: bold;
      color: #5497ce;
      line-height: 28px;
      text-indent: 1em;
    }
    .right-bottom {
      width: 100%;
      margin-top: 20px;
      display: flex;
      align-content: center;
      justify-content: space-between;
      .bottom-left {
        box-sizing: border-box;
        padding: 16px 12px;
        width: 600px;
        height: 296px;
        background: #002a77;
        .handle-con {
          width: 100%;
          display: flex;
          align-content: center;
          justify-content: flex-end;
          .bottom-title {
            font-size: 18px;
            font-family: Microsoft YaHei;
            font-weight: bold;
            color: #5497ce;
            line-height: 28px;
            text-indent: 1em;
          }
          .select-con {
            display: flex;
            align-items: center;
            justify-content: center;
            z-index: 2;
            .select-item {
              width: 88px;
              height: 30px;
              line-height: 30px;
              border: 1px solid #5792c9;
              border-radius: 4px;
              color: #ffffff;
              text-align: center;
              margin: 2px 4px;
              cursor: pointer;
            }
            .select-active {
              background: #5792c9;
            }
          }
        }
        .bottom-chart-con {
          width: 100%;
          height: 200px;
          #live-chart {
            width: 100%;
            height: 100%;
          }
        }
      }
      .bottom-right {
        box-sizing: border-box;
        padding: 16px 12px;
        width: 600px;
        height: 296px;
        background: #002a77;
        .bottom-table {
          margin-top: 10px;
        }
      }
    }
  }
}
</style>
